export const reduxKey = '@@pollEditPopup';

//# sourceMappingURL=constants.js.map